import { http } from './http.service';
import { Product } from '@/types/cart';
class EmailService {
  sendEmail = async (emailContent: { cartId?: number; products: Product[]; emails: string[] }) => {
    const response = await http.post(`/api/cart/send/email`, emailContent);
    return response;
  };
}

export const emailService = new EmailService();
